module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Reward Point",
      "modal": true,
      "visible": _vm.displayBasic,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addRewardPoint.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasic.apply(null, arguments)
            }
          }
        })], 1)])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid "
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "property"
    }
  }, [_vm._v("From")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.amountFrom),
      callback: function($$v) {
        _vm.amountFrom = $$v
      },
      expression: "amountFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "property"
    }
  }, [_vm._v("To")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.amountTo),
      callback: function($$v) {
        _vm.amountTo = $$v
      },
      expression: "amountTo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3"
  }, [_c('label', {
    attrs: {
      "for": "property"
    }
  }, [_vm._v("Reward")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "placeholder": "Point",
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.point),
      callback: function($$v) {
        _vm.point = $$v
      },
      expression: "point"
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('DataTable', {
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.rewardPointLists,
      "paginator": true,
      "rows": 4,
      "data-key": "id"
    }
  }, [_c('Column', {
    attrs: {
      "field": "amountFrom",
      "header": "From"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "To",
      "field": "amountTo"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Point",
      "field": "point"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-success p-button-sm",
          attrs: {
            "type": "button",
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editRewardPoint(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger p-button-sm",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('DeleteDialog', {
    on: {
      "cancel": _vm.closeDeleteDialog,
      "deleted": _vm.deleteRewardPoint
    },
    model: {
      value: (_vm.showDeleteDialog),
      callback: function($$v) {
        _vm.showDeleteDialog = $$v
      },
      expression: "showDeleteDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43d26986"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/RewardPoint.vue
// module id = 2182
// module chunks = 0